import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import "@/styles/ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    honeypot: "" // Anti-spam field
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Honeypot check
    if (formData.honeypot) {
      toast.error("Error al enviar el formulario");
      return;
    }

    setLoading(true);

    try {
      // Usar contact.php en el mismo servidor
      await axios.post('/contact.php', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      toast.success("¡Mensaje enviado exitosamente! Te contactaremos pronto.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        honeypot: ""
      });
    } catch (error) {
      console.error("Error enviando mensaje:", error);
      toast.error("Error al enviar el mensaje. Por favor intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
      <h2 data-testid="form-title">Envíanos un Mensaje</h2>
      <p className="form-description" data-testid="form-description">
        Completa el formulario y nos pondremos en contacto contigo
      </p>

      <div className="form-group">
        <label htmlFor="name">Nombre Completo *</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="Tu nombre"
          data-testid="contact-name-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">Correo Electrónico *</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="tu@email.com"
          data-testid="contact-email-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone">Teléfono *</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          placeholder="829-123-4567"
          data-testid="contact-phone-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="message">Mensaje *</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          rows="5"
          placeholder="Cuéntanos sobre tu proyecto..."
          data-testid="contact-message-input"
        ></textarea>
      </div>

      {/* Honeypot field - hidden from users */}
      <input
        type="text"
        name="honeypot"
        value={formData.honeypot}
        onChange={handleChange}
        style={{ display: "none" }}
        tabIndex="-1"
        autoComplete="off"
        data-testid="contact-honeypot"
      />

      <button 
        type="submit" 
        className="submit-btn" 
        disabled={loading}
        data-testid="contact-submit-btn"
      >
        {loading ? "Enviando..." : "Enviar Mensaje"}
        {!loading && <Send size={18} />}
      </button>
    </form>
  );
};

export default ContactForm;